import L from "leaflet";


L.Control.Legend = L.Control.extend({
    onAdd: function (map) {
        var div = L.DomUtil.create("div", "leaflet-control leaflet-control-layers test");

        div.append(this.options.domElement);
        this.options.domElement.style.display = "block";

        return div;
    },
    onRemove: function (map) {}
});

export function legend(opts) {
    if (!opts.domElement) {
        throw "Missing dom element from layer control";
    }

    return new L.Control.Legend(opts, opts.domElement);
}